import React, { useState } from "react";
import "./LearningJourney.css";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
// import "./PythonLearningJourney.css";
import "./MTLearningJourney.css";

const ManualTestingLearningJourney = () => {
  const [value, setValue] = useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <div className="learning-Journey-container">
        <h2>Manual Testing Learning Journey</h2>
        <div className="lj-menu-wrapper">
          <Box sx={{ width: "100%", typography: "body1" }}>
            <TabContext value={value}>
              <Box>
                <TabList role="tablist"
                  onChange={handleChange}
                  className="main-list"
                  variant="scrollable"
                  scrollButtons="auto"
                  aria-label="lab API tabs example"
                >
                  <Tab label="Overall" value="1" className="list1 item" role="tab" />
                  <Tab label="Aware" value="2" className="list2 item" role="tab" />
                  <Tab label="Equipped" value="3" className="list3 item" role="tab" />
                  <Tab label="Competent" value="4" className="list4 item" role="tab" />
                  {/* <Tab label="Expert" value="5" className='list5 item'/> */}
                </TabList>
              </Box>
              <div className="lj-box">
                <TabPanel value="1" className="comingsoon" role="tabpanel">
                  <div className="lj-images">
                    <a
                      href="https://connectedlearning.accenture.com/topics/manual-testing"
                      target="_blank"
                    >
                      <img
                        src="images/Manual-Testing/Overall-LP.png"
                        alt="overall-img"
                        className="lj-images"
                      />
                    </a>
                  </div>
                </TabPanel>
                <TabPanel value="2" className="comingsoon" role="tabpanel">
                  <div className="lj-images">
                    {/* <img src='images/Manual-Testing/Aware-LP.png' alt='overall-img' className='lj-images' /> */}
                    <div className="LJ-link-Wrapp">
                      {/* <img src='images/Manual-Testing/LearningJourney/Aware/MT-Aware-BG.png' alt='aware-img' className='lj-images' /> */}
                      {/* <div className='linkInner-Container'>
                    <div className='linkContent' id='mtAware'>
                    <p className='link1'>
                      <a href="https://accenture.percipio.com/courses/c369628a-25e3-44b7-b35e-9bdecd0f53e0/videos/37c6aff7-bd51-4e03-9b03-f1e40b05c403" target="_blank"><img src='images/Manual-Testing/LearningJourney/Aware/1.png'/></a>
                    </p>
                    <p className='link2'>
                      <a href="https://accenture.percipio.com/courses/66fdc6c2-8fc8-4a9f-a7e0-cbc4669e603c/videos/e4f7c50a-cfe4-4004-89e8-705ad48b85c5" target="_blank"><img src='images/Manual-Testing/LearningJourney/Aware/2.png'/></a>
                    </p>
                    <p className='link3'>
                      <a href="https://accenture.percipio.com/courses/a61b342d-a6ed-4b30-ab7f-4795b461fd8a/videos/6afc3fb6-6ca1-4b66-aedf-316c91663344" target="_blank"><img src='images/Manual-Testing/LearningJourney/Aware/3.png'/></a>
                    </p>
                    <p className='link4'>
                      <a href="https://www.pluralsight.com/courses/agile-fundamentals" target="_blank"><img src='images/Manual-Testing/LearningJourney/Aware/4.png'/></a>
                    </p>
                    <p className='link5'>
                      <a href="https://accenture.percipio.com/courses/c7c71c9d-e6bc-47e6-a4a1-00089f779e37/videos/f68bfb6e-0093-41cc-925e-8d8d81439c29" target="_blank"><img src='images/Manual-Testing/LearningJourney/Aware/5.png'/></a>
                    </p>
                    <p className='link6'>
                      <a href="https://www.pluralsight.com/courses/software-testing-quality-assurance-big-picture" target="_blank"><img src='images/Manual-Testing/LearningJourney/Aware/6.png'/></a>
                    </p>
                    <p className='link7'>
                      <a href="https://www.pluralsight.com/courses/istqb-foundation-testing-software-development-lifecycle" target="_blank"><img src='images/Manual-Testing/LearningJourney/Aware/7.png'/></a>
                    </p>
                    <p className='link8'>
                      <a href="https://www.pluralsight.com/courses/static-testing-foundation-istqb" target="_blank"><img src='images/Manual-Testing/LearningJourney/Aware/8.png'/></a>
                    </p>
                    <p className='link9'>
                      <a href="https://www.pluralsight.com/courses/istqb-foundation-test-techniques" target="_blank"><img src='images/Manual-Testing/LearningJourney/Aware/9.png'/></a>
                    </p>
                    <p className='link10'>
                      <a href="https://www.pluralsight.com/courses/test-management-istqb-foundation" target="_blank"><img src='images/Manual-Testing/LearningJourney/Aware/10.png'/></a>
                    </p>
                  </div>
                  </div> */}
                      <a
                        href="https://connectedlearning.accenture.com/learningboard/1186023-manual-testing-aware"
                        target="_blank"
                      >
                        <img
                          src="images/Manual-Testing/LearningJourney/Manual-Testing-AWARE.png"
                          alt="aware-img"
                          className="lj-images"
                        />
                      </a>
                    </div>
                  </div>
                </TabPanel>
                <TabPanel value="3" className="comingsoon" role="tabpanel">
                  <div className="lj-images">
                    {/* <img src='images/Manual-Testing/Equipped-LP.png' alt='overall-img' className='lj-images' /> */}
                    <div className="LJ-link-Wrapp">
                      {/* <img src='images/Manual-Testing/LearningJourney/Equipped/MT-Equipped-BG.png' alt='aware-img' className='lj-images' /> */}
                      <a
                        href="https://connectedlearning.accenture.com/learningboard/1186120-manual-testing-equipped"
                        target="_blank"
                      >
                        <img
                          src="images/Manual-Testing/LearningJourney/Manual-Testing-Equipped.png"
                          alt="aware-img"
                          className="lj-images"
                        />
                      </a>
                      {/* <div className='linkInner-Container'>
                    <div className='linkContent' id='mtEquipped'>
                    <p className='link1'>
                      <a href="https://www.pluralsight.com/courses/test-management-istqb-foundation" target="_blank"><img src='images/Manual-Testing/LearningJourney/Equipped/1.png'/></a>
                    </p>
                    <p className='link2'>
                      <a href="https://accenture.percipio.com/courses/7400fbda-82ce-4950-86b6-170d1daa70c3/videos/f948507b-5541-4c1c-8345-fc97514426ee" target="_blank"><img src='images/Manual-Testing/LearningJourney/Equipped/2.png'/></a>
                    </p>
                    <p className='link3'>
                      <a href="https://accenture.percipio.com/courses/cd2912d7-d9c3-11e6-a5b1-0242c0a80503/videos/cd2960f0-d9c3-11e6-a5b1-0242c0a80503" target="_blank"><img src='images/Manual-Testing/LearningJourney/Equipped/3.png'/></a>
                    </p>
                    <p className='link4'>
                      <a href="https://accenture.percipio.com/courses/cd2912d7-d9c3-11e6-a5b1-0242c0a80503/videos/cd2960f6-d9c3-11e6-a5b1-0242c0a80503" target="_blank"><img src='images/Manual-Testing/LearningJourney/Equipped/4.png'/></a>
                    </p>
                    <p className='link5'>
                      <a href="https://accenture.percipio.com/courses/7a0ed867-2109-445e-aba5-efb30e1f976b/videos/bd22d3fb-264e-486f-a8e9-a964f7e0597a?sharelink=y-qpnAsdb" target="_blank"><img src='images/Manual-Testing/LearningJourney/Equipped/5.png'/></a>
                    </p>
                    <p className='link6'>
                      <a href="https://accenture.percipio.com/books/9900deb0-65b0-11e7-a49b-f280cf3fea77#epubcfi(/6/40!/4/2[epubmain]/2[ch02lev1sec6]/2/2/1:0)" target="_blank"><img src='images/Manual-Testing/LearningJourney/Equipped/6.png'/></a>
                    </p>
                    <p className='link7'>
                      <a><img src='images/Manual-Testing/LearningJourney/Equipped/7.png'/></a>
                    </p>
                  </div>
                  </div> */}
                    </div>
                  </div>
                </TabPanel>
                <TabPanel value="4" className="comingsoon" role="tabpanel">
                  <div className="lj-images">
                    {/* <img src='images/Manual-Testing/Component-LP.png' alt='overall-img' className='lj-images' /> */}
                    <div className="LJ-link-Wrapp">
                      {/* <img src='images/Manual-Testing/LearningJourney/Competent/MT-Competent-BG.png' alt='aware-img' className='lj-images' /> */}
                      <a
                        href="https://connectedlearning.accenture.com/learningboard/1186132-manual-testing-competent"
                        target="_blank"
                      >
                        <img
                          src="images/Manual-Testing/LearningJourney/Manual-Testing-Competent.png"
                          alt="aware-img"
                          className="lj-images"
                        />
                      </a>
                      {/* <div className='linkInner-Container'>
                    <div className='linkContent' id='mtCompetent'>
                    <p className='link1'>
                      <a href="https://accenture.percipio.com/courses/a1e45a26-7340-4e3f-a39f-a88cbb22a06d/videos/c0c32c93-1bdf-4b3d-bd45-731c77e02099" target="_blank"><img src='images/Manual-Testing/LearningJourney/Competent/1.png'/></a>
                    </p>
                    <p className='link2'>
                      <a href="https://accenture.percipio.com/courses/7a0a961f-6089-49a8-8ad5-9f41e0d93a2b/videos/581d79d4-b522-401e-a9d3-b7f9b286b6e0" target="_blank"><img src='images/Manual-Testing/LearningJourney/Competent/2.png'/></a>
                    </p>
                    <p className='link3'>
                      <a href="https://mediaexchange.accenture.com/media/t/1_92yzqsh0" target="_blank"><img src='images/Manual-Testing/LearningJourney/Competent/3.png'/></a>
                    </p>
                    <p className='link4'>
                      <a href="https://mediaexchange.accenture.com/media/t/1_9jorum4e" target="_blank"><img src='images/Manual-Testing/LearningJourney/Competent/4.png'/></a>
                    </p>
                    <p className='link5'>
                      <a href="https://mediaexchange.accenture.com/media/t/1_l9qh2psb" target="_blank"><img src='images/Manual-Testing/LearningJourney/Competent/5.png'/></a>
                    </p>
                    <p className='link6'>
                      <a href="https://mediaexchange.accenture.com/media/t/1_11zjgoyb" target="_blank"><img src='images/Manual-Testing/LearningJourney/Competent/6.png'/></a>
                    </p>
                    <p className='link7'>
                      <a href="https://mediaexchange.accenture.com/media/t/1_fmijpnw0" target="_blank"><img src='images/Manual-Testing/LearningJourney/Competent/7.png'/></a>
                    </p>
                    <p className='link8'>
                      <a href="https://mediaexchange.accenture.com/media/t/1_749u56wc" target="_blank"><img src='images/Manual-Testing/LearningJourney/Competent/8.png'/></a>
                    </p>
                    <p className='link9'>
                      <a href="https://mediaexchange.accenture.com/media/t/1_s7k1pfz2" target="_blank"><img src='images/Manual-Testing/LearningJourney/Competent/9.png'/></a>
                    </p>
                    <p className='link10'>
                      <a href="https://mediaexchange.accenture.com/media/t/1_rxxfillz" target="_blank"><img src='images/Manual-Testing/LearningJourney/Competent/10.png'/></a>
                    </p>
                    <p className='link11'>
                      <a href="https://mediaexchange.accenture.com/media/t/1_bua5jnp3" target="_blank"><img src='images/Manual-Testing/LearningJourney/Competent/11.png'/></a>
                    </p>
                    <p className='link12'>
                      <a><img src='images/Manual-Testing/LearningJourney/Competent/12.png'/></a>
                    </p>
                  </div>
                  </div> */}
                    </div>
                  </div>
                </TabPanel>
                {/* <TabPanel value="5" className='comingsoon'>Coming Soon</TabPanel> */}
              </div>
            </TabContext>
          </Box>
        </div>
      </div>
    </>
  );
};
export default ManualTestingLearningJourney;
